import container from './container';
import CommonInputAdapter from './adapters/common-input';

export { default } from './utils/form-manager';
export const FormContainer = container;
export const InputAdapter = CommonInputAdapter;
